module.exports = __webpack_public_path__ + "static/media/banner3.4fc86bb2.png";